import { useEffect } from "react";
import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const addNoscriptToBody = () => {
  const noscriptElement = document.createElement('noscript');
  const noscriptContent = document.createTextNode(`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2189712477923429&ev=PageView&noscript=1" />`);
  noscriptElement.appendChild(noscriptContent);
  document.body.appendChild(noscriptElement);
};

const addNoscriptToBodyGA = () => {
  const noscriptElement = document.createElement('noscript');
  const noscriptContent = document.createTextNode(`<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PCNNHBQK"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`);
  noscriptElement.appendChild(noscriptContent);
  document.body.appendChild(noscriptElement);
};


export default function MainLayout({ children }) {
  const location = useLocation();

  useEffect(() => {
    addNoscriptToBody();
    addNoscriptToBodyGA();
  }, []);

  useEffect(() => {
    const updateGtmHelper = () => {
      const titleDiv = document.querySelector('[data-gtm-title]');
      const slugDiv = document.querySelector('[data-gtm-slug]');
      if (titleDiv) titleDiv.setAttribute('data-gtm-title', document.title || '');
      if (slugDiv) slugDiv.setAttribute('data-gtm-slug', window.location.pathname || '');
    };

    updateGtmHelper();
    // schedule a microtask to catch any title updates from Helmet
    setTimeout(updateGtmHelper, 0);
  }, [location.pathname]);

  return (
    <div>
      <Helmet>
        <script>{`
        if (navigator.userAgent !== 'ReactSnap') {
          if(${window.location.hostname === 'inbrija.com' || window.location.hostname === 'www.inbrija.com'}){
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-PCNNHBQK');
            }
          }`
        }</script>
        <script>{`
          if (navigator.userAgent !== 'ReactSnap') {
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '2189712477923429');
            fbq('track', 'PageView');
          }`
        }</script>
        {/* <!-- Uptime Real User Monitoring Code --> */}
        <script>{`
        if (navigator.userAgent !== 'ReactSnap') {
            (function(w,d,s){w._uptime_rum2 = {};w._uptime_rum2.errors=[];w._uptime_rum2.uuid='TT6M-08D4B1F8DEDD542D';w._uptime_rum2.url='https://rumcollector.uptime.com';s=document.createElement('script');s.async=1;s.src='https://rum.uptime.com/static/rum/compiled/v2/rum.js';d.getElementsByTagName('head')[0].appendChild(s);w.addEventListener('error',function(e){w._uptime_rum2.errors.push({ t: new Date(), err: e })});})(window,document);
        }`}</script>
        {/* <!-- End Uptime Real User Monitoring Code --> */}

      </Helmet>
      <main>
        {children}
      </main>
    </div>
  )
}